module.exports = __webpack_public_path__ + "img/banner5.2a74d3d9.png";